import React from "react";
import Sidebar from "../Dashboard/Sidebar";
export default function Calendar() {
  return (
    <div>
      <Sidebar />
      <h2>Calendar</h2>
    </div>
  );
}
